module.exports = __webpack_public_path__ + "static/media/btn_listeningvoice9a0e291e532df7ebeee08a9073ceec3f.webp";